import { render, staticRenderFns } from "./SalesNewsLibrary.vue?vue&type=template&id=51fa6788"
import script from "./SalesNewsLibrary.vue?vue&type=script&lang=js"
export * from "./SalesNewsLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports